import {Component, EventEmitter, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../../services/user.service';

@Component({
  templateUrl: './password-verification-dialog.component.html',
  styleUrls: ['./password-verification-dialog.component.scss']
})
export class PasswordVerificationDialogComponent implements OnInit {

  private verified = new EventEmitter<void>();
  passwordError: boolean;
  submitted = false;
  form: FormGroup;

  constructor(private dialogRef: MatDialogRef<PasswordVerificationDialogComponent>,
              private service: UserService,
              private builder: FormBuilder,
              private router: Router) {
  }

  ngOnInit() {
    this.dialogRef.disableClose = true;
    this.form = this.builder.group({'password': ['', [Validators.required, Validators.minLength(6)]]});
  }

  submit(value) {
    this.submitted = true;
    if (this.form.invalid) return;
    this.service.checkPassword({password: value.password}).subscribe(() => {
      this.verified.emit();
      this.dialogRef.close();
    }, () => this.passwordError = true);
  }

  cancel() {
    this.dialogRef.close();
    this.router.navigate(['/']);
  }

  public promise() {
    return new Promise<void>(resolve => this.verified.subscribe(() => resolve()));
  }

  get f() {
    return this.form.controls;
  }
}
